export enum MenuTypeEnum {
  Primary = 'primary',
  Mega = 'mega',
  Level = 'level',
  Submenu = 'submenu',
}
